/**
 * 用于检查登录状态，未登录时弹出登录弹窗
 * @param callback 已登录时执行的回调函数
 */
export const useAuthGuard = () => {
  const authStore = useAuthStore()
  const loginStore = useLoginStore()

  const requireAuth = (callback?: () => void) => {
    if (!authStore.isAuthenticated) {
      loginStore.openLoginModal('SignIn')
      return false
    }
    if (callback) {
      callback()
    }
    return true
  }

  return {
    requireAuth
  }
}

